module.exports = __webpack_public_path__ + "img/login-background3.ad7e4e9c.jpg";